export const muiTabsTheme = {
  MuiTabs: {
    styleOverrides: {
      root: ({ theme }) => ({
        minHeight: 'auto',
        '.MuiTabs-scroller': {
          '.MuiTabs-indicator': {
            background: theme.palette.kit.text.h,
          },
        },
      }),
    },
  },
};
